import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'whatwg-fetch'

import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import './textStyles.scss'
import './buttonStyles.scss'
import { Router } from 'react-router-dom'
import { StylesProvider } from '@material-ui/styles'
import BasicApp from './fhg/components/app/BasicApp'
import { jss, overrideTheme } from './config/theme'
import { messages } from './config/locale'
import App from './App'

import { IMSProvider } from './components/eval/list/IMSFormCategorySelect'
import { IMSFormProvider } from './components/eval/detail/IMSForm/IMSFormContext'
import { disableConsole } from './Utils/DisableConsole'
import { initializeDatadog } from './config/datadog'
import { initializeSentry } from './config/sentry'
import { createCustomHistory } from './config/history'
import { initializeStringFormat } from './Utils/stringFormat'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './config/queryClient'
import { initializeLogs } from './config/logger'

import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-pluralrules/dist/locale-data/en'

// Initialize configurations
//disableConsole();
initializeLogs()
initializeDatadog()
initializeSentry()
initializeStringFormat()
const customHistory = createCustomHistory() // Create custom history

export { registerServiceWorkerPromise } from './config/serviceWorker' // Export service worker promise

ReactDOM.render(
    <QueryClientProvider client={queryClient}>
        <StylesProvider jss={jss}>
            <BasicApp theme={overrideTheme} messages={messages}>
                <Router history={customHistory}>
                    <IMSFormProvider>
                        <IMSProvider>
                            <App />
                        </IMSProvider>
                    </IMSFormProvider>
                </Router>
            </BasicApp>
        </StylesProvider>
    </QueryClientProvider>,
    document.getElementById('root')
)
